var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.className,style:(_vm.styles),attrs:{"aria-hidden":"true","data-fa-transform":_vm.transforms,"data-fa-mask":_vm.maskIcon}})}
var staticRenderFns = []

export { render, staticRenderFns }